// src/components/Movimiento/MovimientoForm.js
import React from "react";
import { Button, Form, FormGroup, Input, Label, Alert } from "reactstrap";
import axios from "axios";
import Select, { createFilter } from "react-select";
import {
  API_URL_movimientos,
  API_URL_proyectos,
  API_URL_partners,
  buildSedesWithSubsUrl,
} from "../../constants";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { getAuthHeaders } from "../../utils/auth";
class MovimientoForm extends React.Component {
  state = {
    pk: null,
    proyecto_code: "",
    proyecto: "",
    movimiento_txt: "",
    descripcion: "",
    valueStream: "",
    boxScore: "",
    miembro_comp: "",
    accrued_week_no: 1, // default 1

    cuenta: "",
    fecha: "",
    referencia_alfa: "",
    referencia_numerica: "",
    autorizacion: "",
    movimiento: "",
    depositos: "",
    retiros: "",
    saldo: "",

    proyectos: [],
    partners: [],
    formType: "",
    sedes: [],
    availableSubcats: [],
    selectedSubcat: "",
    errorMessage: "",
  };

  componentDidMount() {
    // Prefill when editing
    if (this.props.movimiento) {
      const m = this.props.movimiento;
      const safePk = m.pk ?? m.id ?? null;

      this.setState({
        pk: safePk,
        proyecto_code: m.proyecto_code || "",
        proyecto: m.proyecto || "",
        movimiento_txt: m.movimiento_txt || "",
        cuenta: m.cuenta || "",
        fecha: m.fecha || "",
        referencia_alfa: m.referencia_alfa || "",
        referencia_numerica: m.referencia_numerica || "",
        autorizacion: m.autorizacion || "",
        movimiento: m.movimiento || "",
        depositos: m.depositos ?? "",
        descripcion: m.descripcion || "",
        retiros: m.retiros ?? "",
        saldo: m.saldo ?? "",
        valueStream: m.valueStream || "",
        boxScore: m.boxScore || "",
        partners: Array.isArray(m.partners) ? m.partners : [],
        miembro_comp: m.miembro_comp || "",
        accrued_week_no: m.accrued_week_no ?? 1,
      });
    }

    const headers = getAuthHeaders();

    // Proyectos
    axios
      .get(API_URL_proyectos, { headers })
      .then((response) => {
        const proyectos = (response.data || []).filter(
          (p) => p.status !== "Terminado"
        );
        this.setState({ proyectos });
      })
      .catch((error) => console.error("Error fetching Proyectos:", error));

    // Partners
    axios
      .get(API_URL_partners, { headers })
      .then((res) => this.setState({ partners: res.data || [] }))
      .catch((error) => console.log(error));

    // Sedes + subcategories
    axios
      .get(buildSedesWithSubsUrl(), { headers })
      .then((res) => {
        const sedes = Array.isArray(res.data) ? res.data : [];
        this.setState({ sedes }, () => {
          const { valueStream } = this.state;
          if (valueStream) {
            const found = sedes.find((s) => s.sede === valueStream);
            const availableSubcats = Array.isArray(found?.subcategories)
              ? found.subcategories
              : [];
            this.setState({ availableSubcats });
          }
        });
      })
      .catch((err) => console.log("Error loading sedes:", err));
  }

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleProyectoChange = (e) => {
    const selected = e.target.value || "";
    if (!selected) {
      this.setState({ proyecto: "", proyecto_code: "" });
      return;
    }
    const [name, code] = selected.split("|");
    this.setState({ proyecto: name, proyecto_code: code });
  };

  handleSedeChange = (e) => {
    const sedeName = e.target.value;
    const found = this.state.sedes.find((s) => s.sede === sedeName);
    const availableSubcats = found?.subcategories || [];
    this.setState({
      valueStream: sedeName,
      availableSubcats,
      selectedSubcat: "",
    });
  };

  handleSubcatChange = (e) => {
    this.setState({ selectedSubcat: e.target.value });
  };

  handleFormTypeChange = (e) => {
    const value = e.target.value || "";
    // When switching to "proyecto", reset BoxScore and weeks
    if (value === "proyecto") {
      this.setState({
        formType: value,
        boxScore: "",
        accrued_week_no: 1,
      });
    } else {
      this.setState({ formType: value });
    }
  };

  normalizeNumber = (value) => {
    if (value === null || value === undefined) return 0;
    const trimmed = String(value).trim();
    if (!trimmed) return 0;
    const normalized = trimmed.replace(",", ".");
    const num = Number(normalized);
    return Number.isNaN(num) ? 0 : num;
  };

  buildPayload = () => {
    const {
      pk,
      proyecto_code,
      proyecto,
      movimiento_txt,
      descripcion,
      valueStream,
      boxScore,
      miembro_comp,
      accrued_week_no,
      cuenta,
      fecha,
      referencia_alfa,
      referencia_numerica,
      autorizacion,
      movimiento,
      depositos,
      retiros,
      saldo,
      selectedSubcat,
    } = this.state;

    const descWithSub =
      selectedSubcat && !String(descripcion).includes("[Subcat:")
        ? `${descripcion || ""}${descripcion ? " " : ""}[Subcat: ${selectedSubcat}]`
        : descripcion || "";

    return {
      pk,
      proyecto_code,
      proyecto,
      movimiento_txt,
      descripcion: descWithSub,
      valueStream,
      boxScore,
      miembro_comp,
      accrued_week_no: Math.max(1, Number(accrued_week_no) || 1),

      cuenta,
      fecha,
      referencia_alfa,
      referencia_numerica,
      autorizacion,
      movimiento,
      depositos: this.normalizeNumber(depositos),
      retiros: this.normalizeNumber(retiros),
      saldo: this.normalizeNumber(saldo),
    };
  };

  createMovimiento = (e) => {
    e.preventDefault();
    const headers = getAuthHeaders();
    const payload = this.buildPayload();

    axios
      .post(API_URL_movimientos, payload, { headers })
      .then(() => {
        this.props.resetState();
        this.props.toggle();
      })
      .catch((error) => {
        let msg = "Error al crear movimiento.";
        if (error.response?.data) msg += " " + JSON.stringify(error.response.data);
        this.setState({ errorMessage: msg });
      });
  };

  editMovimiento = (e) => {
    e.preventDefault();
    const headers = getAuthHeaders();
    const payload = this.buildPayload();
    const { pk } = this.state;

    if (!pk || pk <= 0) {
      this.setState({
        errorMessage:
          "ID de movimiento inválido. No se puede actualizar el registro.",
      });
      return;
    }

    axios
      .put(`${API_URL_movimientos}${pk}/`, payload, { headers })
      .then(() => {
        this.props.resetState();
        this.props.toggle();
      })
      .catch((error) => {
        let msg = "Error updating movimiento.";
        if (error.response?.data) msg += " " + JSON.stringify(error.response.data);
        this.setState({ errorMessage: msg });
      });
  };

  renderFormContent = () => {
    const {
      formType,
      proyectos,
      partners,
      sedes,
      valueStream,
      availableSubcats,
      selectedSubcat,
      boxScore,
      accrued_week_no,
    } = this.state;

    // Filter option for react-select (search without accents)
    const filterOption = createFilter({
      ignoreAccents: true,
      ignoreCase: true,
      trim: true,
      matchFrom: "any",
    });

    // BoxScore options
    const boxScoreOptions = [
      { value: "revenue", label: "Revenue" },
      { value: "other", label: "Other Revenue" },
      { value: "direct", label: "Direct Cost + Partner Share" },
      { value: "conversionVS", label: "Value Stream Conversion Cost" },
      { value: "investmentVS", label: "Value Stream Investment" },
      { value: "conversion", label: "Conversion Cost General Services" },
      { value: "investmentGS", label: "Investment General Services" },
      { value: "tax", label: "Tax" },
    ];

    // Shared BoxScore + Weeks block (used in both "proyecto" and "movimiento")
    const boxScoreAndWeeks = (
      <>
        <FormGroup>
          <Label>Rubro de Box Score:</Label>
          <Select
            options={boxScoreOptions}
            value={boxScoreOptions.find((o) => o.value === boxScore) || null}
            onChange={(opt) => this.onChange({ target: { name: 'boxScore', value: opt ? opt.value : "" }})}
            placeholder="Selecciona rubro Box Score"
            isClearable
            filterOption={filterOption}
          />
        </FormGroup>

        <FormGroup>
          <Label>Numero de Semanas a Devengar:</Label>
          <Input
            type="number"
            name="accrued_week_no"
            min="1"
            value={accrued_week_no}
            onChange={(e) =>
              this.setState({
                accrued_week_no: Math.max(1, Number(e.target.value) || 1),
              })
            }
          />
        </FormGroup>
      </>
    );

    if (formType === "proyecto") {
      // Proyecto options
      const proyectoOptions = Array.isArray(proyectos)
        ? proyectos
            .slice()
            .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
            .map((p) => ({
              value: `${p.name}|${p.proyecto_code}`,
              label: p.name
            }))
        : [];

      return (
        <>
          <FormGroup>
            <Label for="proyecto">Selecciona Proyecto</Label>
            <Select
              options={proyectoOptions}
              value={proyectoOptions.find((o) => o.value === `${this.state.proyecto}|${this.state.proyecto_code}`) || null}
              onChange={(opt) => this.handleProyectoChange({ target: { value: opt ? opt.value : "" }})}
              placeholder="Selecciona proyecto"
              isClearable
              filterOption={filterOption}
            />
          </FormGroup>

          {boxScoreAndWeeks}
        </>
      );
    }

    if (formType === "movimiento") {
      // Value Stream options
      const sedeOptions = Array.isArray(sedes)
        ? sedes.map((s) => ({ value: s.sede, label: s.sede }))
        : [];

      // Subcategoría options
      const subcatOptions = Array.isArray(availableSubcats)
        ? availableSubcats.map((sc) => ({ value: sc.name, label: sc.name }))
        : [];

      return (
        <>
          <FormGroup>
            <Label>Value Stream:</Label>
            <Select
              options={sedeOptions}
              value={sedeOptions.find((o) => o.value === valueStream) || null}
              onChange={(opt) => this.handleSedeChange({ target: { value: opt ? opt.value : "" }})}
              placeholder="Selecciona Value Stream"
              isClearable
              filterOption={filterOption}
            />
          </FormGroup>

          <FormGroup>
            <Label>Subcategoría:</Label>
            <Select
              options={subcatOptions}
              value={subcatOptions.find((o) => o.value === selectedSubcat) || null}
              onChange={(opt) => this.handleSubcatChange({ target: { value: opt ? opt.value : "" }})}
              placeholder="Selecciona Subcategoría"
              isClearable
              filterOption={filterOption}
              isDisabled={!valueStream}
            />
          </FormGroup>

          {boxScoreAndWeeks}
        </>
      );
    }

    if (formType === "miembro_compartido") {
      // Partner options
      const partnerOptions = Array.isArray(partners)
        ? partners
            .slice()
            .sort((a, b) => (a.partner || "").localeCompare(b.partner || ""))
            .map((p) => ({ value: p.partner, label: p.partner }))
        : [];

      return (
        <FormGroup>
          <Label>Selecciona Miembro</Label>
          <Select
            options={partnerOptions}
            value={partnerOptions.find((o) => o.value === this.state.miembro_comp) || null}
            onChange={(opt) => this.onChange({ target: { name: 'miembro_comp', value: opt ? opt.value : "" }})}
            placeholder="Selecciona miembro compartido"
            isClearable
            filterOption={filterOption}
          />
        </FormGroup>
      );
    }

    return null;
  };

  render() {
    const { errorMessage, formType } = this.state;

    // Filter option for react-select (search without accents)
    const filterOption = createFilter({
      ignoreAccents: true,
      ignoreCase: true,
      trim: true,
      matchFrom: "any",
    });

    // Options for form type select
    const formTypeOptions = [
      { value: "proyecto", label: "Selecciona Proyecto" },
      { value: "movimiento", label: "Movimiento de Box Score" },
      { value: "miembro_compartido", label: "Miembro Compartido" },
    ];

    return (
      <Form
        onSubmit={
          this.props.movimiento ? this.editMovimiento : this.createMovimiento
        }
      >
        <FormGroup>
          <Label>Elige una opción</Label>
          <Select
            options={formTypeOptions}
            value={formTypeOptions.find((o) => o.value === formType) || null}
            onChange={(opt) => this.handleFormTypeChange({ target: { value: opt ? opt.value : "" }})}
            placeholder="Selecciona..."
            isClearable
            filterOption={filterOption}
          />
        </FormGroup>

        {this.renderFormContent()}

        {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
        <Button>Enviar</Button>
      </Form>
    );
  }
}

export default MovimientoForm;